import React from 'react'

function Profile() {
 
  return (
    <div>
      <div className="h-10 m-0 p-0 bg-slate-500 opacity-30" style={{borderRadius:'4px'}}>
          <input type="text" className=" m-2" style={{borderRadius: '4px'}} placeholder="Search"/>
        </div>
      <div>profile</div>
    
    </div>
  )
}

export default Profile